import React from 'react';
import { IconProps } from '../../types/icons';
import './icon.scss';

const EmailIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="emailicon"
      viewBox="0 0 24 24"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M20.9902 5.83789C20.9902 5.28561 20.5425 4.83789 19.9902 4.83789H4C3.44772 4.83789 3 5.28561 3 5.83789V17.1621C3 18.2667 3.89543 19.1621 5 19.1621H19C20.1046 19.1621 21 18.2667 21 17.1621V6.16211C21 6.11449 20.9967 6.06765 20.9902 6.0218V5.83789ZM19 8.06165V17.1621H5V8.06199L9.87851 12.9405C11.0501 14.1121 12.9496 14.1121 14.1211 12.9405L19 8.06165ZM17.4277 6.80554H6.57198L11.2927 11.5263C11.6832 11.9168 12.3164 11.9168 12.7069 11.5263L17.4277 6.80554Z" fill={fill || '#7E8A96'} />
    </svg>
  );
};

export default EmailIcon;
